import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { isInDevelopment } from "../config";
import Auth from "../helpers/auth";
import "./CompanyList.css";
import CompanyListItem from "./CompanyListItem";
import DeveloperButton from "./DevloperButton";
import { translate } from "./Language/Translate";
;

function CompanyList() {
  // const [isLoading, setIsLoading] = useState(true);
  const [activeId, setActiveId] = useState(0);
  const companies = useSelector((st) => st.companies);
  const userStatus = useSelector((st) => st.currentUser)?.userStatus;

  return (
    <div>
      {userStatus==="developer" && isInDevelopment &&  <DeveloperButton/>}
      <h4>Schule ({companies.length}):</h4>
      <p>Klicken Sie auf einen Schule, um Einzelheiten zu sehen.</p>
      {Auth.isMainAdmin(userStatus) && (
        <p>
          Klichen Sie auf "Schule hinzufügen" um einen neuen Schule anzulegen.
        </p>
      )}
      {Auth.isMainAdmin(userStatus) && (
        <Link to="/companies/new" className="btn btn-outline-dark my-4">
          {translate("Add Company")}
        </Link>
      )}

      <div>
        {companies.map((company) => (
          <CompanyListItem
            company={company}
            activeId={activeId}
            setActiveId={setActiveId}
            key={company.id}
          />
        ))}
      </div>
    </div>
  );
}

export default CompanyList;
